interface RankingItem {
  rank: number;
  title: string;
  author: string;
  category: string;
  updateInfo: string;
  heat: string;
  imageUrl: string;
}

const rankingData: RankingItem[] = [
  {
    rank: 1,
    title: '我的温柔暴君',
    author: '李惠',
    category: '韩漫·恋爱',
    updateInfo: '更新至第89话',
    heat: '12.6w',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20manga%20style%20illustration%20with%20warm%20coral%20and%20soft%20cream%20background%2C%20abstract%20artistic%20composition%20with%20flowing%20lines%2C%20no%20text%20no%20characters%2C%20minimalist%20aesthetic%2C%20soft%20gradients%2C%20comic%20panel%20inspired%20layout&width=160&height=200&seq=ranking-01&orientation=portrait',
  },
  {
    rank: 2,
    title: '重生之都市修仙',
    author: '百里屠苏',
    category: '国漫·仙侠',
    updateInfo: '更新至第156话',
    heat: '11.3w',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20manga%20style%20cover%20with%20amber%20and%20cream%20accents%2C%20abstract%20flowing%20composition%2C%20dynamic%20energy%2C%20no%20text%20no%20characters%2C%20minimalist%20warm%20gradient%20design&width=160&height=200&seq=ranking-02&orientation=portrait',
  },
  {
    rank: 3,
    title: '暗黑童话',
    author: '金敏秀',
    category: '韩漫·悬疑',
    updateInfo: '更新至第42话',
    heat: '9.8w',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20dark%20moody%20manga%20style%20cover%20with%20deep%20coral%20red%20and%20charcoal%20tones%2C%20abstract%20mysterious%20composition%2C%20no%20text%20no%20characters%2C%20dramatic%20minimalist%20design&width=160&height=200&seq=ranking-03&orientation=portrait',
  },
  {
    rank: 4,
    title: '剑道独尊',
    author: '风凌天下',
    category: '国漫·热血',
    updateInfo: '更新至第203话',
    heat: '8.7w',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20bold%20manga%20style%20cover%20with%20warm%20orange%20red%20and%20cream%20contrast%2C%20abstract%20energetic%20brushstroke%20design%2C%20no%20text%20no%20characters%2C%20dynamic%20minimalism&width=160&height=200&seq=ranking-04&orientation=portrait',
  },
  {
    rank: 5,
    title: '邻家天使',
    author: '佐藤真昼',
    category: '日漫·校园',
    updateInfo: '更新至第67话',
    heat: '7.5w',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20soft%20manga%20style%20cover%20with%20pastel%20coral%20and%20cream%20gradients%2C%20gentle%20flowing%20abstract%20shapes%2C%20no%20text%20no%20characters%2C%20light%20airy%20minimalist%20design&width=160&height=200&seq=ranking-05&orientation=portrait',
  },
  {
    rank: 6,
    title: '末日生存指南',
    author: '黑曜石',
    category: '国漫·科幻',
    updateInfo: '更新至第78话',
    heat: '6.9w',
    imageUrl: 'https://readdy.ai/api/search-image?query=A%20futuristic%20manga%20style%20cover%20with%20muted%20coral%20and%20silver%20gray%20tones%2C%20abstract%20geometric%20composition%2C%20no%20text%20no%20characters%2C%20clean%20modern%20minimalist%20design&width=160&height=200&seq=ranking-06&orientation=portrait',
  },
];

export default function Ranking() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              热门排行
            </h2>
            <p className="text-sm text-foreground-600">本周最受读者欢迎的漫画作品</p>
          </div>
          <a href="#index" className="hidden sm:inline-flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium cursor-pointer whitespace-nowrap">
            查看全部 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {rankingData.map((item) => (
            <a
              key={item.rank}
              href="#cards"
              className="group flex items-center gap-4 p-4 rounded-lg bg-background-50 border border-background-200 hover:border-primary-200 hover:bg-primary-50/30 transition-all duration-200 cursor-pointer"
            >
              <div className="relative flex-shrink-0 w-16 h-20 md:w-18 md:h-24 rounded-md overflow-hidden bg-background-200">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
                <div className="absolute top-0 left-0 w-6 h-6 flex items-center justify-center bg-primary-500 text-background-50 text-xs font-bold rounded-br-md">
                  {item.rank}
                </div>
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors truncate">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5">{item.author} · {item.category}</p>
                <p className="text-xs text-foreground-600 mt-1">{item.updateInfo}</p>
                <div className="flex items-center gap-1 mt-1.5">
                  <span className="w-4 h-4 flex items-center justify-center text-accent-500">
                    <i className="ri-fire-line text-xs"></i>
                  </span>
                  <span className="text-xs text-accent-600 font-medium">{item.heat}热度</span>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="mt-6 text-center sm:hidden">
          <a href="#index" className="inline-flex items-center gap-1 text-sm text-primary-600 font-medium cursor-pointer">
            查看全部排行 <i className="ri-arrow-right-line"></i>
          </a>
        </div>
      </div>
    </section>
  );
}